/**
 * Servicio que se encarga del manejo de las transacciones del login por empresa.
 * JMM-2019-02-28
 */
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class LoginempresaService {

  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener empresa
   * JMM-2019-02-28
   */
  getEmpresa(nit:any)
  {
    let url = this.PATH + '/api/login_empresa/' + nit;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEmpresa()

 /**
   * Permite obtener los usuarios conectados
   * CESAR ARIAS -2019-11-05
   */
  usuarioConectado(nit:any)
  {
    let url = this.PATH + '/api/usuarioConectado/'+nit;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getEmpresa()


  getUsuarioActivos(data)
  {
    let url = this.PATH + '/api/getUsuarioActivos';
    return this.http.post(url,data ,{headers:this._key.head()}).map(resp => resp.json());
  }// .getEmpresa()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/login/loginempresa.service.ts